import { render, staticRenderFns } from "./TaskCard.vue?vue&type=template&id=f8a676f4&scoped=true&"
import script from "./TaskCard.vue?vue&type=script&lang=ts&"
export * from "./TaskCard.vue?vue&type=script&lang=ts&"
import style0 from "./TaskCard.vue?vue&type=style&index=0&id=f8a676f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a676f4",
  null
  
)

export default component.exports